/* tempexp_18869-full-file tempexp_18955-full-file */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, IS_MBIZUSER, IS_MOBILE_BROWSER, IS_PAID_USER, IS_PUBLIC } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type HeavyFileBuyAb = 'b' | 'c' | 'd';
type HeavyFileBuyConfig = { transact: string; usual: string };

const userCondition = IS_PAID_USER || IS_BIZ_USER || IS_MBIZUSER || IS_CORP_USER;
const envCondition = IS_MOBILE_BROWSER || IS_PUBLIC;
const featureCondition = !userCondition && !envCondition;

const value: HeavyFileBuyAb | 'a' | false = getFeature('heavy-file-buy');
const valueV3: HeavyFileBuyAb | 'a' | false = getFeature('heavy-file-buy-v3');

// TODO: после экспа эти тарифы для выбранного варианта перенести в promoTariffs фичу в онлайнконфе
const abHeavyFileBuyConfigAll: Record<HeavyFileBuyAb, HeavyFileBuyConfig> = getFeature('heavy-file-buy-tariffs') || {
    b: { transact: 'W1KB_1h_big_file_upload_a', usual: 'W128GB_1m_free_paid_account' },
    c: { transact: 'W1KB_1h_big_file_upload_b', usual: 'W128GB_1m_free_paid_account' },
    d: { transact: 'W1KB_1h_big_file_upload_c', usual: 'W128GB_1m_free_paid_account' },
};

const configTransactTariffsList = Object.values(abHeavyFileBuyConfigAll).map((item) => item.transact);

// TODO: после экспа эти тарифы для выбранного варианта перенести в promoTariffs фичу в онлайнконфе
const abHeavyFileBuyConfigAllV3: Record<HeavyFileBuyAb, HeavyFileBuyConfig> = getFeature('heavy-file-buy-tariffs-v3') || {
    b: { transact: 'W1KB_1hour', usual: 'auto' },
    c: { transact: 'W1KB_1h_transaction_payments_v3', usual: 'auto' },
    d: { transact: 'W1KB_1h_transaction_payments_v3', usual: 'auto' },
};

const configTransactTariffsListV3 = Object.values(abHeavyFileBuyConfigAllV3).map((item) => item.transact);

// все транзакционные тарифы должны быть перечислены тут, даже старые
// TODO: перенести в онлайнконф после экспов
const allTransactTariffsList = getFeature('heavy-file-buy-tariffs-list') || [
    'W1KB_1h_big_file_upload_a',
    'W1KB_1h_big_file_upload_b',
    'W1KB_1h_big_file_upload_c',
    'W1KB_1hour',
    'W1KB_1h_transaction_payments_v3',
];

export const abHeavyFileBuyTariffsList = [
    ...new Set([...configTransactTariffsList, ...configTransactTariffsListV3, ...allTransactTariffsList]),
];

export const abHeavyFileBuyV3: HeavyFileBuyAb | false = featureCondition && valueV3 !== 'a' && valueV3;
export const abHeavyFileBuyConfigV3: HeavyFileBuyConfig = (abHeavyFileBuyV3 && abHeavyFileBuyConfigAllV3[abHeavyFileBuyV3]) || {
    transact: '',
    usual: '',
};

export const abHeavyFileBuy: HeavyFileBuyAb | false = featureCondition && value !== 'a' && value;
export const abHeavyFileBuyConfig: HeavyFileBuyConfig = (abHeavyFileBuy && abHeavyFileBuyConfigAll[abHeavyFileBuy]) || {
    transact: '',
    usual: '',
};

if (featureCondition) {
    registerExperiment(
        'hfb-v3',
        valueV3,
        [
            AnalyticEventNames.BIG_FILE_DIALOG_SHOW,
            AnalyticEventNames.BIG_FILE_DIALOG_CLOSE,
            AnalyticEventNames.BIG_FILE_DIALOG_CLICK,
            AnalyticEventNames.BIG_FILE_CLICK_BUY_ONCE,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
        ],
        {
            mapEventNames: {
                [AnalyticEventNames.BIG_FILE_DIALOG_CLICK]: 'click_usual',
                [AnalyticEventNames.BIG_FILE_CLICK_BUY_ONCE]: 'click_transact',
            },
            sendXrayArgs: {
                [AnalyticEventNames.BIG_FILE_DIALOG_SHOW]: ({ stage }) => ({ eventName: `show_${stage}` }),
                [AnalyticEventNames.BIG_FILE_DIALOG_CLOSE]: ({ stage }) => ({ eventName: `close_${stage}` }),
                [AnalyticEventNames.TARIFF_BUY]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    switch (paySource) {
                        case 'cloud_popup_heavy_file_trial':
                            name = 'heavy_trial_buy';
                            break;
                        case 'cloud_popup_heavy_file_onetime':
                            name = 'heavy_once_buy';
                            break;
                        case 'cloud_popup_heavy_file':
                            name = 'heavy_buy';
                            break;
                        default:
                            break;
                    }

                    return {
                        eventName: name,
                    };
                },
                [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    switch (paySource) {
                        case 'cloud_popup_heavy_file_trial':
                            name = 'heavy_trial_checkout';
                            break;
                        case 'cloud_popup_heavy_file_onetime':
                            name = 'heavy_once_checkout';
                            break;
                        case 'cloud_popup_heavy_file':
                            name = 'heavy_checkout';
                            break;
                        default:
                            break;
                    }

                    return {
                        eventName: name,
                    };
                },
            },
        }
    );
    registerExperiment(
        'hfb-v2',
        value,
        [
            AnalyticEventNames.BIG_FILE_DIALOG_SHOW,
            AnalyticEventNames.BIG_FILE_DIALOG_CLOSE,
            AnalyticEventNames.BIG_FILE_DIALOG_CLICK,
            AnalyticEventNames.BIG_FILE_CLICK_BUY_ONCE,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
        ],
        {
            sendXrayArgs: {
                [AnalyticEventNames.TARIFF_BUY]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    switch (paySource) {
                        case 'cloud_popup_heavy_file_trial':
                            name = 'heavy_trial_buy';
                            break;
                        case 'cloud_popup_heavy_file_onetime':
                            name = 'heavy_once_buy';
                            break;
                        case 'cloud_popup_heavy_file':
                            name = 'heavy_buy';
                            break;
                        default:
                            break;
                    }

                    return {
                        eventName: name,
                    };
                },
                [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => {
                    let name = eventName;

                    switch (paySource) {
                        case 'cloud_popup_heavy_file_trial':
                            name = 'heavy_trial_checkout';
                            break;
                        case 'cloud_popup_heavy_file_onetime':
                            name = 'heavy_once_checkout';
                            break;
                        case 'cloud_popup_heavy_file':
                            name = 'heavy_checkout';
                            break;
                        default:
                            break;
                    }

                    return {
                        eventName: name,
                    };
                },
            },
        }
    );
}
